import { reviewRejectApi } from "../../api/review/reviewRejectApi"

type PayloadShape = Parameters<typeof reviewRejectApi>[0]

export async function reviewRejectService(payload: PayloadShape, token: string) {
	return await reviewRejectApi(payload, token)
}
